import {
  Text,
  GreyGrey80,
  Primary16Regular,
  Primary24SemiBold,
  StandardLayout,
  Flex
} from '@sequencehq/core-components'
import { AutomationsList } from './components/AutomationsList'
import { ButtonNewWorkflow, HeaderKebabMenu } from './components'
import { AutomationExecutionsHistory } from './executionsHistory'

const PageHeading = () => (
  <Flex flexDir="column" gap="8px">
    <Text {...Primary24SemiBold} color={GreyGrey80}>
      Workflows
    </Text>
    <Text {...Primary16Regular} color={GreyGrey80}>
      Manage and automate all your business logic in Sequence.
    </Text>
  </Flex>
)

export const AutomationsManagement = () => {
  return (
    <>
      <StandardLayout
        header={
          <StandardLayout.Header
            title="Workflows"
            actions={
              <StandardLayout.Actions>
                <ButtonNewWorkflow />
                <HeaderKebabMenu />
              </StandardLayout.Actions>
            }
          />
        }
        content={
          <StandardLayout.Content scrollable>
            <Flex
              flexDir="column"
              maxWidth="1060px"
              marginX="auto"
              padding="16px 16px 32px 16px"
              gap="48px"
            >
              <PageHeading />
              <AutomationsList />
            </Flex>
          </StandardLayout.Content>
        }
      />
      <AutomationExecutionsHistory />
    </>
  )
}
